import type * as ents from '@attain-apps/entities'
import { StringCase, transformCase } from '@attain-apps/string-utils'

// TODO: Use ents.core.common interfaces to build up this.
export interface Tab extends ents.core.common.Named {
  index: number
}
export namespace Tab {
  /**
   * Creates a stable, URL-safe token from a tab name so tab selection can be
   * persisted and restored from query params across reloads and deep links.
   */
  export function stringify(tab: Tab | undefined): string {
    const normalizedTabName = (tab?.name ?? '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^A-Za-z0-9_-]+/g, '')
      .replace(/[-_]+/g, '-')
      .replace(/^-+|-+$/g, '')

    if (!normalizedTabName) {
      return 'tab'
    }

    try {
      const tabToken = transformCase(normalizedTabName, StringCase.Kebab)
      return tabToken || 'tab'
    } catch {
      return normalizedTabName.toLowerCase() || 'tab'
    }
  }
}
